<script setup lang="ts">
/** 1.c Agreement by members to shorter notice (S.177). 서명 = 주주([[Signers]] = AgmSigners 위젯). members_scope 토글. */
import CddVarField from '../../aura/agm/cdd/CddVarField.vue';
import AgmSigners from '../../aura/agm/cdd/AgmSigners.vue';
import { useAgmFill } from '../../aura/agm/cdd/useCddFill';
import '../../aura/agm/docs/agmDoc.css';

const fill = useAgmFill();
function val(k: string) { return String(fill.values[k] ?? '').trim(); }
function setSel(k: string, v: string) { fill.setValue(k, val(k) === v ? '' : v); }
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head" style="text-align:center">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>Unique Entity Number: <CddVarField field-key="company_uen" label="UEN" /></div>
      <div>(“the Company”)</div>
    </div>

    <p class="sec-title" style="text-align:center;margin-top:14px">AGREEMENT BY MEMBERS TO SHORTER NOTICE THAN IS REQUIRED UNDER SECTION 177(2) OF THE SINGAPORE COMPANIES ACT 1967 TO BE GIVEN FOR AN ANNUAL GENERAL MEETING</p>

    <p class="doc-p">Pursuant to Section 177(3)(a) of the Singapore Companies Act 1967, I/we, the undersigned, being the
      <span class="doc-toggle" :class="{ off: val('members_scope') !== 'sole' }" @click="setSel('members_scope','sole')">sole</span> /
      <span class="doc-toggle" :class="{ off: val('members_scope') !== 'all' }" @click="setSel('members_scope','all')">all the</span>
      member(s) of <CddVarField field-key="company_name" label="Company Name" /> entitled to attend and vote at a General Meeting of the Company hereby agree that the
      <CddVarField field-key="agm_number" label="AGM number (e.g. 20th)" /> Annual General Meeting of the Company to be held on
      <CddVarField field-key="meeting_date" label="Meeting date" /> shall, notwithstanding that it is called by notice shorter than is required by Section 177(2) of the Act, be deemed to be duly called.</p>

    <p class="doc-p">Dated this <CddVarField field-key="agreement_date" label="Agreement date" /></p>

    <!-- [[Signers]] — 주주 서명(AgmSigners 위젯). 좌측 'S H A R E H O L D E R S' 제목은
         서명 블록의 가운데 'Shareholders' 라벨과 중복이라 제거(고객 요청). -->
    <!-- 1인 가운데 고정(패널 signBlockLayout 'agreement') — 옵션 잠금 -->
    <AgmSigners var-key="agm_member_Signers" board-label="Shareholders" center-locked />
  </div>
</template>

<style scoped>
.doc-company { font-weight: 800; font-size: 13.5px; }
</style>
